export default __webpack_public_path__ + "static/media/21_MestMarzipan-Commercial-EschweilerPhotography_21A0473.4afad74c.jpg";